import React from 'react';

import { RichContent, Flex, Typography } from 'components';
import { useTheme } from 'styled-components';

interface VideoTranscriptionProps {
  transcription?: string;
  name: string;
}

const VideoTranscription = ({ name, transcription }: VideoTranscriptionProps) => {
  const { currentTheme } = useTheme();

  return (
    <>
      <Flex position="relative" bg="commentsBg" py={{ m: 6, d: 8 }} px={{ m: 4, d: 10 }} style={{ gap: 26 }} flexDirection="column">
        <Flex flexGrow={0} flexDirection="column" style={{ gap: 2 }}>
          <Typography type="type1" color="color50" upper>
            Transcrição da aula
          </Typography>

          <Typography type="type5" fontWeight="bold" color="color100">
            {name}
          </Typography>
        </Flex>

        <RichContent currentTheme={currentTheme}>{transcription}</RichContent>
      </Flex>
    </>
  );
};

export default VideoTranscription;
